import { apiClient } from '@app/lib'
import { type SugarExpendituresFilters, type SugarExpendituresPaginatedResponse } from '@app/types'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useExpenditures = (page: number = 1, filters: SugarExpendituresFilters = {}) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated',
    placeholderData: keepPreviousData,
    queryKey: ['expenditures', filters, page],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarExpendituresPaginatedResponse>('/api/expenditures', {
        params: {
          ...filters,
          page: Math.max(1, page)
        }
      })

      return data
    }
  })
}
